
























import Vue from 'vue'
import moment from 'moment'

import cTrend from './trend.vue'
import { Parameter, InfluxResult } from '@/api/cems'

import { EChartsOption } from 'echarts'

function generateMarkline(parameter: Parameter) {
  return {
    data: [{ yAxis: parameter.standar }],
    lineStyle: {
      color: '#FF0000',
    },
    label: {
      show: false,
      formatter: 'Baku mutu: {c}',
      position: 'middle',
      backgroundColor: '#FF0000df',
      color: '#ffffff',
      padding: 3,
      borderColor: '#aeaeae',
      borderWidth: 1,
      borderRadius: 3,
    },
  }
}

export default Vue.extend({
  name: 'MultipleTrend',
  components: { cTrend },
  props: {
    value: {
      type: Object,
      required: true,
    },
    params: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // eslint-disable-next-line
      charts: [] as any[],
      parameters: [] as Parameter[],
    }
  },
  methods: {
    async updateTrend(result: InfluxResult) {
      // eslint-disable-next-line
      const newCharts: any[] = []

      if (!result.Series) {
        this.charts = []
        return
      }

      if (result.Series.length == 0) {
        this.charts = []
        return
      }

      const values = result.Series[0].values

      const options: EChartsOption = {
        animation: false,
        grid: {
          top: 20,
          left: '2%',
          right: '2%',
          bottom: '10%',
          containLabel: true,
        },
        backgroundColor: 'transparent',
        title: {
          show: false,
          textAlign: 'center',
          left: 'center',
          top: 10,
          textStyle: {
            align: 'center',
            fontWeight: 'normal',
            fontSize: 12,
            lineHeight: 10,
          },
          subtextStyle: {
            fontSize: 11,
            color: '#000',
            lineHeight: 10,
            align: 'left',
          },
        },

        tooltip: {
          trigger: 'axis',
        },
        legend: {
          bottom: 10,
          left: 10,
          icon: 'rect',
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 13,
          textStyle: {
            fontSize: 11,
          },
          formatter: function(name: string) {
            return 'Legend ' + name
          },
        },
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#57617B',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: true,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#57617B',
              },
            },
            axisLabel: {
              margin: 10,
            },
            splitLine: {},
          },
        ],
      }

      for (let i = 1; i < result.Series[0].columns.length; i++) {
        const columnName = result.Series[0].columns[i]

        const parameter = this.parameters.find((p) => p.name == columnName)

        if (typeof parameter == 'undefined') {
          continue
        }

        // eslint-disable-next-line
        const serie: any = {
          name: columnName,
          htmlTitle: parameter.nameHTML,
          color: parameter.color || '#008Eda',
          type: 'line',
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          // areaStyle: {
          //   opacity: 0.15,
          // },
          itemStyle: {
            normal: {
              borderWidth: 12,
            },
          },
          data: values.map((value) => {
            return [value[0], value[i]]
          }),
        }

        const opts = JSON.parse(JSON.stringify(options))

        if (parameter.standarEnabled) {
          opts.title.subtext = `Baku mutu: ${parameter.standar}`
          serie.markLine = generateMarkline(parameter)
          opts.bakuMutu = parameter.standar
          opts.engineeringUnit =
            parameter.engineeringUnitHTML || parameter.engineeringUnit
        }

        opts.title.text = parameter.nameHTML || parameter.name

        opts.title.link = '/cems/historical-trend/' + parameter.uid
        opts.name = parameter.name
        opts.series = [serie]
        if (parameter.max != parameter.min) {
          opts.yAxis[0] = {
            ...opts.yAxis[0],
            max: parameter.max,
            min: parameter.min,
          }
        }

        const nextCoulmnName = result.Series[0].columns[i + 1]
        if (nextCoulmnName == columnName + '.av') {
          const avSerie = JSON.parse(JSON.stringify(serie))
          avSerie.name = 'AV'
          avSerie.data = values.map((value) => {
            return [value[0], value[i + 1]]
          })
          // avSerie.lineStyle = {
          //   type: 'dashed',
          // }
          opts.series.push(avSerie)
        }

        // const chartIndex = this.charts.findIndex(
        //   (chart) => chart.name == opts.name
        // )

        opts.tooltip = {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: '#57617B',
            },
          },
          formatter: (
            // eslint-disable-next-line
            params: any | any[],
            ticket: string,
            callback: (ticket: string, html: string) => void
          ) => {
            if (params.length < 1) {
              return
            }

            setTimeout(() => {
              const time = moment(params[0].axisValue).format(
                'DD MMM YYYY, HH:mm:ss'
              )

              let result = `
              <div><small>${time}</small></div>
              `
              // eslint-disable-next-line
              params.map((p: { [key: string]: any }) => {
                const parameter = this.parameters.find(
                  (par) => par.name == p.seriesName
                )
                const value = p.data[1]
                if (parameter) {
                  let v = ''
                  if (typeof value == 'number') {
                    v = value.toFixed(parameter.precision || 3)
                  }
                  const name = parameter.nameHTML || parameter.name
                  result += `<div>${
                    p.marker
                  } ${name}: ${v} ${parameter.engineeringUnitHTML ||
                    parameter.engineeringUnit}</div>`
                } else {
                  result += `<div>${p.marker} ${p.seriesName} : ${value}</div>`
                }
              })

              callback(ticket, result)
            }, 10)

            return 'Loading...'
          },
        }

        newCharts.push(opts)
      }

      this.charts = newCharts
    },
  },

  watch: {
    value: {
      deep: true,
      handler: function(val: InfluxResult) {
        this.updateTrend(val)
      },
    },

    params: function(val: Parameter[]) {
      this.parameters = val
    },
  },

  created() {
    this.parameters = this.params as Parameter[]
    this.updateTrend(this.value)
  },
})
